import React from 'react';
import { useTranslation } from 'react-i18next';
import { WeekView } from '@devexpress/dx-react-scheduler-material-ui';
import useScheduleCalendarContext from 'components/ScheduleCalendar/context/useScheduleCalendarContext';
import gradients from 'config/material-ui/gradients';
import { secondsInHour, secondsInMinute } from 'helpers/timeConsts';
import TimeTableHoverComponent from 'components/AddWorkSchedule/WorkScheduleCalendar/libComponents/TimeTableHoverComponent';
import { getHours, getMinutes, endOfDay } from 'date-fns';
import { draftScheduleWorkingHoursId } from '../context/ScheduleCalendarProvider';

export default function TimeTableCellComponent({
  startDate,
  endDate,
  ...restProps
}: WeekView.TimeTableCellProps) {
  const {
    scheduleRanges,
    draftScheduleWorkingHours,
    handleAddDraftScheduleWorkingHours,
    isDraftCreating,
    setIsDraftCreating,
    updateEndDateOfDraftScheduleWorkingHours,
    setDraftAnchorEl,
  } = useScheduleCalendarContext();
  const dayOffWeek = startDate ? startDate.getDay() : null;
  const { t } = useTranslation();
  const isLastTile =
  getHours(endDate as Date) === 23 && getMinutes(endDate as Date) === 59;
const convertedEndDate = isLastTile ? endOfDay(endDate as Date) : endDate as Date;

  const checkIsCellInScheduleRange = () => {
    const scheduleRange = scheduleRanges.find(
      (range) => range.day === dayOffWeek,
    );

    if (!scheduleRange) {
      return false;
    }

    if (!startDate || !convertedEndDate) {
      return false;
    }

    const cellTimeStart =
      startDate.getHours() * secondsInHour +
      startDate.getMinutes() * secondsInMinute;
    const cellTimeEnd =
    convertedEndDate.getHours() * secondsInHour +
    convertedEndDate.getMinutes() * secondsInMinute;

    if (
      cellTimeStart < scheduleRange.timeFrom ||
      cellTimeEnd > scheduleRange.timeTo
    ) {
      return false;
    }

    return true;
  };

  const addScheduleToState = () => {
    setIsDraftCreating(true);
    handleAddDraftScheduleWorkingHours({
      id: draftScheduleWorkingHoursId,
      project: '',
      projectPhase: '',
      seconds: secondsInHour,
      employee: '',
      startDate: startDate as Date,
      endDate: convertedEndDate,
      description: '',
    });
  };

  return (
    <WeekView.TimeTableCell
      data-end={convertedEndDate}
      data-start={startDate}
      {...restProps}
      style={{
        height: '5rem',
      }}
      sx={{
        cursor: draftScheduleWorkingHours ? 'default' : 'pointer',
        background: checkIsCellInScheduleRange()
          ? 'inherit'
          : gradients.GRAY_DIAGONAL_STRIPES,
        backgroundSize: '1.5rem 1.5rem',
        position: 'relative',
        '&:hover .MuiPaper-root': {
          opacity: 1,
        },
        '&:hover.MuiTableCell-root.Cell-cell': {
          backgroundColor: 'main.white',
        },
      }}
      onMouseDown={() => {
        addScheduleToState();
      }}
      onMouseMove={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const target = event.target as HTMLDivElement;
        if (!isDraftCreating || !target.dataset.end) {
          return;
        }
        updateEndDateOfDraftScheduleWorkingHours(new Date(target.dataset.end));
      }}
      onMouseUp={(event: {
        currentTarget: React.SetStateAction<HTMLDivElement | null>;
      }) => {
        if (!draftScheduleWorkingHours) {
          return;
        }
        setIsDraftCreating(false);
        setDraftAnchorEl(event.currentTarget);
      }}
    >
      {!isDraftCreating && (
        <TimeTableHoverComponent label={t('project_tracking.log_task')} />
      )}
    </WeekView.TimeTableCell>
  );
}
